import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ComposerErrorOverlay = () => {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "error",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'composer-ui.capability-editor.error.loading-capabilities'
    })
  });
};
ComposerErrorOverlay.displayName = 'ComposerErrorOverlay';
export default ComposerErrorOverlay;